import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:865
* @route '/teacher/settings/experience'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/settings/experience',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:865
* @route '/teacher/settings/experience'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:865
* @route '/teacher/settings/experience'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const experience = {
    update: Object.assign(update, update),
}

export default experience